import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { getTestIds } from '../../utils/TestIds';
import { Box, Column, Row } from '../Layout';
export const GetAiFiltersTID = (parentTestId)=>getTestIds(parentTestId);
export const AiFilters = (param)=>{
    let { testId, input, searchRowActions, chips, banner, gap = 8, searchRowGap = 16 } = param;
    const { AiFiltersTestIds } = useMemo(()=>GetAiFiltersTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(Box, {
        testId: testId,
        width: "100%",
        children: /*#__PURE__*/ _jsxs(Column, {
            gap: gap,
            width: "100%",
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    testId: AiFiltersTestIds.SearchRow(),
                    gap: searchRowGap,
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    children: [
                        input,
                        searchRowActions
                    ]
                }),
                chips,
                banner
            ]
        })
    });
};
